import { primitives } from "@einride/ui"

// chartColorPalette is ordered where the first colors will be used first
export const chartColorPalette = [
  // mid
  primitives.color.blue[60],
  primitives.color.green[60],
  primitives.color.violet[60],
  primitives.color.orange[60],
  primitives.color.yellow[60],
  // bright
  primitives.color.blue[20],
  primitives.color.green[20],
  primitives.color.violet[20],
  primitives.color.orange[20],
  primitives.color.yellow[20],
  // dark
  primitives.color.blue[80],
  primitives.color.green[80],
  primitives.color.violet[80],
  primitives.color.orange[80],
  primitives.color.yellow[80],
  // medium bright
  primitives.color.blue[40],
  primitives.color.green[40],
  primitives.color.violet[40],
  primitives.color.orange[40],
  primitives.color.yellow[40],
]

export const getColor = (colors: string[], index: number): string => {
  // repeat color if the index is outside of chartColorPalette
  return colors[index % colors.length]
}

export function getColors(
  colors: string[],
  legends: { value: string; label: string }[],
  identifier: string,
): string {
  const index = legends.findIndex((legend) => legend.label === identifier)
  // repeat the colors if there are more legends than colors
  return getColor(colors, index)
}
